import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import { includes, isEmpty, isNil, map } from 'lodash';
import { Image } from 'react-bootstrap';

import LayersCollection from '../../../api/Layers/Layers';
import { getId, getName, isTileServer, getImageURL } from '../../../api/Layers/layer-operations';
import { getLayerSubTypesForMapTypes } from '../../../api/Maps/Maps';

import GalleryItemCheckbox from '../GalleryItemCheckbox';
import Loading from '../Loading';
import MapContainerMapThumbnail from '../../containers/MapContainerMapThumbnail';

const DEFAULT_THUMBNAIL_IMAGE = '/map-gallery-default.png';

const GalleryThumbnail = ({ layer, deployEnv, defaultBaseMap }) => {
  let imageToShow = DEFAULT_THUMBNAIL_IMAGE;
  let windowHeight = '';
  const windowSize = window.innerWidth;
  switch (true) {
    case windowSize <= 800:
      windowHeight = '50px';
      break;
    case windowSize > 800 && windowSize <= 850:
      windowHeight = '110px';
      break;
    case windowSize > 850 && windowSize <= 875:
      windowHeight = '125px';
      break;
    default:
      windowHeight = '130px';
      break;
  }
  if (!isEmpty(getImageURL(layer))) {
    imageToShow = getImageURL(layer);
  } else if (isTileServer(layer)) {
    return (
      <div
        className="img-fluid rounded"
        style={{
          height: '16vw',
          width: '16vw',
          maxHeight: windowHeight,
          maxWidth: '140px',
          minWidth: '110px',
          minHeight: '50px'
        }}
      >
        <MapContainerMapThumbnail
          layer={layer}
          defaultBaseMap={defaultBaseMap}
          deployEnv={deployEnv}
        />
      </div>
    );
  }
  return (
    <div
      className="img-fluid rounded"
      style={{
        height: '16vw',
        width: '16vw',
        maxHeight: windowHeight,
        maxWidth: '140px ',
        minWidth: '110px',
        minHeight: '110px'
      }}
    >
      <Image
        src={imageToShow}
        className="fluid "
        style={{ height: '100%', width: '100%', borderRadius: '5px' }}
      />
    </div>
  );
};

GalleryThumbnail.propTypes = {
  layer: PropTypes.object.isRequired,
  defaultBaseMap: PropTypes.object.isRequired,
  deployEnv: PropTypes.string.isRequired
};

class BaseMapsSelector extends Component {
  componentDidMount() {
    const { totalCount, updateTotalCount, loading } = this.props;
    if (!loading) updateTotalCount(totalCount);
  }

  componentDidUpdate(prevProps) {
    const { totalCount: oldTotalCount, loading: oldLoading } = prevProps;
    const { totalCount, updateTotalCount, loading } = this.props;
    if (!loading && oldLoading) {
      updateTotalCount(totalCount);
    }
    if (!loading && totalCount !== oldTotalCount) {
      updateTotalCount(totalCount);
    }
  }

  render() {
    const {
      layerList,
      selectLayer,
      selectBaseMap,
      deployEnv,
      loading,
      selectedLayers,
      selectedBaseMaps,
      defaultBaseMap
    } = this.props;

    const allSelectedLayers = [...selectedLayers, ...selectedBaseMaps];

    if (loading) return <Loading />;

    return map(layerList, layer => (
      <GalleryItemCheckbox
        key={getId(layer)}
        title={getName(layer)}
        handleCheckedBox={selectLayer}
        isLayerSelected={includes(allSelectedLayers, getId(layer))}
        selectLayer={() => selectLayer(getId(layer))}
        selectBaseMap={() => selectBaseMap(getId(layer))}
        layerName={getName(layer)}
      >
        <GalleryThumbnail layer={layer} defaultBaseMap={defaultBaseMap} deployEnv={deployEnv} />
      </GalleryItemCheckbox>
    ));
  }
}

BaseMapsSelector.defaultProps = {
  defaultBaseMap: {}
};

BaseMapsSelector.propTypes = {
  layerList: PropTypes.array.isRequired,
  selectLayer: PropTypes.func.isRequired,
  selectBaseMap: PropTypes.func.isRequired,
  deployEnv: PropTypes.string.isRequired,
  updateTotalCount: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  selectedLayers: PropTypes.array.isRequired,
  selectedBaseMaps: PropTypes.array.isRequired,
  defaultBaseMap: PropTypes.object
};

export default withTracker(({ searchQuery, mapType, userControlSetting }) => {
  const skip = searchQuery.currentPage * searchQuery.perPage - searchQuery.perPage;
  const sort = {
    name: 1 // ascending
  };
  const layerQuery = {
    deleted: { $eq: 'no' },
    layerSubType: { $in: getLayerSubTypesForMapTypes(mapType) }
  };

  const searchRegex = !isEmpty(searchQuery.search) ? new RegExp(searchQuery.search, 'i') : null;
  if (!isNil(searchRegex)) {
    layerQuery.name = searchRegex;
  }

  const sortOptions = { limit: searchQuery.perPage, skip, sort };

  const layersSub = Meteor.subscribe('layers');

  return {
    loading: !layersSub.ready(),
    layerList: LayersCollection.find(layerQuery, sortOptions).fetch(),
    totalCount: LayersCollection.find(layerQuery).count(),
    defaultBaseMap: LayersCollection.findOne(userControlSetting.defaultBaseMap)
  };
})(BaseMapsSelector);
